export const getPositionMarkerIcon = () =>
  `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="8" fill="#1976d2" fill-opacity="0.25"/>
  <circle cx="12" cy="12" r="4" fill="#1976d2"/>
</svg>
  `;
